import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Alert,
  CircularProgress,
  Grid
} from '@mui/material';
import axios from 'axios';

const ConferenceAddUpdateTermsAndConditions = () => {
  const eventid = localStorage.getItem('eventid');
  const [termsEn, setTermsEn] = useState('');
  const [termsAr, setTermsAr] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null); // { type: 'success'|'error', text }

  // Load existing terms
  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const { data } = await axios.get(`/api/conference/index-terms-and-conditions?id=${eventid}`);
        setTermsEn(data.terms_en || '');
        setTermsAr(data.terms_ar || '');
      } catch (err) {
        setMessage({ type: 'error', text: 'Failed to load existing terms.' });
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, [eventid]);

  const handleSave = async () => {
    if (!termsEn.trim() && !termsAr.trim()) {
      setMessage({ type: 'error', text: 'At least one language must have content.' });
      return;
    }

    setSaving(true);
    setMessage(null);

    try {
      await axios.post('/api/conference/terms-and-conditions', {
        eventid: eventid,
        terms_en: termsEn,
        terms_ar: termsAr
      });

      setMessage({
        type: 'success',
        text: 'Terms and Conditions saved/updated successfully!'
      });
    } catch (err) {
      setMessage({ type: 'error', text: 'Failed to save terms and conditions.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ mt: 20, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 15, mb: 10 }}>

      <Typography variant="h5" gutterBottom sx={{ mb: 5 }}>
        {termsEn || termsAr ? 'Update Conference Terms & Conditions' : 'Add Conference Terms & Conditions'}
      </Typography>

      {message && (
        <Alert severity={message.type} sx={{ mb: 3 }}>
          {message.text}
        </Alert>
      )}

      <Grid container spacing={4}>
        {/* English Input */}
        <Grid item xs={12} md={6}>
          <TextField
            label="Terms and Conditions (English)"
            multiline
            minRows={10}
            fullWidth
            value={termsEn}
            onChange={(e) => setTermsEn(e.target.value)}
            variant="outlined"
          />
        </Grid>

        {/* Arabic Input */}
        <Grid item xs={12} md={6}>
          <TextField
            label="الشروط والأحكام (Arabic)"
            multiline
            minRows={10}
            fullWidth
            value={termsAr}
            onChange={(e) => setTermsAr(e.target.value)}
            variant="outlined"
            inputProps={{ style: { direction: 'rtl', textAlign: 'right' } }}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={20} /> : null}
        >
          {saving ? 'Saving...' : 'Save Terms'}
        </Button>
      </Box>
    </Container>
  );
};

export default ConferenceAddUpdateTermsAndConditions;
